<script setup lang="ts">
import { useTextFilter } from "@/composables/filters/text-filter";
import { useDebounceFn } from "@vueuse/core";
import { inject, onActivated } from "vue";
import type { PagingFilter } from "@/composables/filters/paging-filter";
import { pagingFilterSymbol } from "@/plugins/ContentFiltersPlugin";

const props = defineProps<{ placeholder: string }>();

const { resetSearchText, hasSearchValue, textSearchFilter } = useTextFilter();

function notifySearch() {
  // TODO: send event to BlueShift about search criteria
}

const onInput = useDebounceFn( () => {
  // TODO: highlight displayable text based on search text value
  resetPageNumber();
}, 500 );

onActivated( () => {
  resetSearchText();
} );

const pagingFilter = inject< PagingFilter >( pagingFilterSymbol ) as PagingFilter;
function resetPageNumber() {
  pagingFilter?.resetPageNumber();
}
</script>

<template>
  <div class="relative">
    <FloatLabel variant="on">
        <InputText
            id="textSearchFilter"
            ref="search"
            v-model="textSearchFilter"
            @input="onInput"
            @change="notifySearch"
            class="input w-full"/>
            <label id="textSearchFilter" for="textSearchFilter">{{ props.placeholder }}</label>
    </FloatLabel>
    <div @click="resetSearchText" class="absolute right-3 top-3">
      <i class="pi text-sm" :class="hasSearchValue ? 'pi-times' : 'pi-search'"></i>
    </div>
  </div>
</template>
